import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBNIRCXc0ROFnGKyn97UT0RCrZTLfPALyY",
  authDomain: "data-center-service-5be9f.firebaseapp.com",
  databaseURL: "https://data-center-service-5be9f-default-rtdb.firebaseio.com",
  projectId: "data-center-service-5be9f",
  storageBucket: "data-center-service-5be9f.appspot.com",
  messagingSenderId: "591199345084",
  appId: "1:591199345084:web:e5b4fb25f1c471641db3b9",
  measurementId: "G-QYY93HTP54",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

export { db, storage };
